import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import CardTag from "../EntityCard/CardTag";
import { ServiceReminderStatus } from "../../utils/serviceReminderStatus";

interface Props {
    status: ServiceReminderStatus;
    nextDueDate?: string | null;
}

const STATUS_COLOR: Record<ServiceReminderStatus, "danger" | "warning" | "success" | "neutral"> = {
    overdue: "danger",
    dueSoon: "warning",
    ok: "success",
    none: "neutral",
};

/**
 * Small colored status chip used on reminder cards. Shows "Overdue",
 * "Due in N days", "OK" or "No due date" depending on the next due date.
 */
const ServiceReminderStatusPill = ({ status, nextDueDate }: Props) => {
    const { t } = useTranslation();

    const label = (() => {
        switch (status) {
            case "overdue":
                return t("Overdue");
            case "dueSoon": {
                const days = Math.max(0, moment(nextDueDate).startOf("day").diff(moment().startOf("day"), "days"));
                return days === 0 ? t("Due today") : t("Due in {{count}} days", { count: days });
            }
            case "ok":
                return t("On schedule");
            default:
                return t("No due date");
        }
    })();

    return (
        <CardTag label={label} color={STATUS_COLOR[status]} />
    );
};

export default ServiceReminderStatusPill;
